<template>
  <Responsive
    :breakpoints="{
      small: (el) => el.width <= 480
    }"
  >
    <div class="px-4 scrollable-container" slot-scope="el" @click.prevent.stop="">
      <div style="overflow: auto; height: 100%">
        <div style="width: calc(100% - 20px)">
          <template v-for="menuItemGroup in menuItemsGroups">
            <v-layout py-2 row wrap align-content-start :key="menuItemGroup.key">
              <v-flex
                class="px-2"
                :class="{ sm12: el.is.small, sm6: !el.is.small }"
                xs12
                v-for="menuitem in menuItemGroup.values"
                :key="menuitem.cmp"
              >
                <v-btn
                  color="primary"
                  :disabled="
                    !fleetSecurity[menuitem.securityKey].enable ||
                    (menuitem.mustBeActive && !isActive(currentDetailFleet.fleet))
                  "
                  :input-value="tabCreated(menuitem.cmp)"
                  class="menu-btn"
                  outline
                  @click="$store.myActions.FLEET_NAVTO_DETAIL({ cmp: menuitem.cmp, isleft, id: -1 })"
                >
                  <v-icon v-if="menuitem.icon" left v-html="menuitem.icon"></v-icon>
                  {{ tryTranslate(menuitem.label) }}
                  <v-spacer />
                </v-btn>
              </v-flex>
            </v-layout>
            <v-divider :key="`hr_${menuItemGroup.key}`" />
          </template>
        </div>
      </div>
    </div>
  </Responsive>
</template>
<script lang="ts">
import Vue from 'vue'
import Component from 'vue-class-component'
import { SecurityItemsKeys } from '@/enum/SecurityItems'
import { groupBy } from '@/utils/groupBy'
import { FLEETS_DETAIL_TABS } from '@/models/ui/FleetTabs'
import { FleetType } from '@/enum/FleetType'
import { AloDbFleet, isAloDbFleetCoverage, isAloDbFleetFormation, isAloDbFleetFree } from '@/models/alodb/AloDbFleet'

@Component({
  name: 'FleetMenu',
  props: {
    isleft: Boolean
  }
})
export default class FleetMenu extends Vue {
  isleft!: boolean

  get currentDetailFleet() {
    return this.$store.myGetters.currentDetailFleet
  }

  get menuItemsGroups() {
    return groupBy(
      FLEETS_DETAIL_TABS.filter(
        (m) =>
          this.fleetSecurity[m.securityKey].visible &&
          m.securityKey != SecurityItemsKeys.HIDDEN &&
          // RG-DON-026d — Images seulement si l'enseigne de la flotte a le post-traitement image
          (m.securityKey != SecurityItemsKeys.PILOT_DETAIL_IMAGE ||
            !!this.$store.getters.enseigneConfigFor(this.currentDetailFleet.fleet.ENS_ID)?.postprocess_image) &&
          (m.usedFor.length == 0 ||
            (m.usedFor.includes(FleetType.FREE) && isAloDbFleetFree(this.currentDetailFleet.fleet)) ||
            (m.usedFor.includes(FleetType.COVERAGE) && isAloDbFleetCoverage(this.currentDetailFleet.fleet)) ||
            (m.usedFor.includes(FleetType.FORMATION) && isAloDbFleetFormation(this.currentDetailFleet.fleet)))
      ),
      (m) => m.group
    )
  }

  get tabItems() {
    return this.isleft ? this.currentDetailFleet.tabsleft.tabs : this.currentDetailFleet.tabsright.tabs
  }
  get fleetSecurity() {
    return this.currentDetailFleet.fleet.security
  }

  tabCreated(cmp: string) {
    return this.tabItems.findIndex((it) => it.cmp == cmp) > -1
  }

  tryTranslate(key: string) {
    const transKey = `Pilot.FleetDetailMenu.${key}`
    const trad = this.$t(transKey)
    return transKey == trad ? key : trad
  }

  isActive(fleet: AloDbFleet) {
    return fleet.activeMissionIds?.some((misId) => this.$store.myGetters.missionsById[misId]?.misActifOn) ?? false
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scope>
.menu-btn {
  width: 100%;
  min-width: 230px;
  border-radius: 8px;
}
hr {
  margin: 0.5em auto;
}
hr:last-child {
  display: none;
}
</style>
